import React from 'react'
// import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import { 
  MainTitle, Subtitle,
  TextContent, HighlightText,
  JsonCodeStyle,
} from '../../../Shared';

import { StyledTableCell, StyledTableRow, useTableStyles } from '../../styles/Table.styled';
import { StyledSeparated } from '../FindNearSegments/FindNearSegments.styled';

function createData(fields, type, description) {
  return { fields, type, description };
}

const listQueryParams = [
  createData('zoom','number','zoom level of map, example: 18'),
  createData('time','Date','Timestamp of current time'),
  createData('lat','number','latitude of position'),
  createData('lng','number','longitude of position'),
]

const GetTrafficStatus = props => {
  const classes = useTableStyles();

  const responseSuccess = {
    "code": 200,
    "message": "success",
    "data": [
      {
        "_id": "5f8bc32efd75bf3cf2b19275",
        "distance": 24333,
        "time": 148.75780000000012,
        "coords": [
          {
            "_id": 20940,
            "polyline": {
              "coordinates": [
                [106.6775012, 10.7944978],
                [106.6770814, 10.7947481]
              ],
              "_id": "5f8bd03dfd75bf3cf2b1ac9d",
              "type": "LineString"
            },
            "priority": 2,
            "segment": 20940,
            "source": "base-data",
            "velocity": 25,
            "color": "#009900",
            "street": {
              "name": "Nguyễn Văn Trỗi",
              "type": "primary"
            }
          },
          {
            "_id": 29687,
            "polyline": {
              "coordinates": [
                [106.6770439, 10.7946532],
                [106.6775747, 10.7943378]
              ],
              "_id": "5f8bd03dfd75bf3cf2b1ac9e",
              "type": "LineString"
            },
            "priority": 2,
            "segment": 29687,
            "source": "base-data",
            "velocity": 15,
            "color": "#ffcc00",
            "street": {
              "name": "Nguyễn Văn Trỗi",
              "type": "primary"
            }
          }
          //.........
        ]
      }
    ]
  }

  const responseErrors = {
    "code": 400,
    "message": "Bad input parameter",
    "errors": [
      {
        "reason": "required",
        "message": "\"lat\" is required",
        "domain": "lat"
      },
      {
        "reason": "invalid",
        "message": "\"date\" is not allowed",
        "domain": "date"
      }
    ],
    "debugError": {
      "isJoi": true,
      "name": "ValidationError",
      "details": [
        {
          "message": "\"lat\" is required",
          "path": ["lat"],
          "type": "any.required",
          "context": {
            "key": "lat",
            "label": "lat"
          }
        },
        {
          "message": "\"date\" is not allowed",
          "path": ["date"],
          "type": "object.allowUnknown",
          "context": {
            "child": "date",
            "value": "1602998292539",
            "key": "date",
            "label": "date"
          }
        }
      ],
      "_object": {
        "zoom": "18",
        "time": "1602998292539",
        "date": "1602998292539",
        "lng": "106.6772127205456"
      }
    }
  }

  return (
    <div>
      <MainTitle>Get Traffic Status</MainTitle>
      <TextContent>Get traffic status of specific position</TextContent>
      <Subtitle id="request-direct">Request</Subtitle>
      <TextContent><b><i>URI: </i></b><HighlightText>/api/segment/get-status</HighlightText> </TextContent>
      <TextContent><b><i>Method: </i></b>@GET</TextContent>
      <TextContent><b><i>Query params:</i></b></TextContent>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Code</StyledTableCell>
              <StyledTableCell align="left">Message</StyledTableCell>
              <StyledTableCell align="left">Detail</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listQueryParams.map((row) => (
              <StyledTableRow key={row.fields}>
                <StyledTableCell>
                  {row.fields}
                </StyledTableCell>
                <StyledTableCell align="left">{row.type}</StyledTableCell>
                <StyledTableCell component="th" scope="row" align="left">{row.description}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Subtitle id="response-direct">Response</Subtitle>
      <Subtitle isSmall id="success-direct">Success</Subtitle>
      <TextContent><b><i>api: </i></b><HighlightText>https://api.bktraffic.com/api/traffic-status/get-status?zoom=18&time=1602998292539&lat=10.7947045759207&lng=106.6772127205456</HighlightText> </TextContent>
      <JsonCodeStyle data={responseSuccess} />

      <Subtitle isSmall id="success-direct">Errors</Subtitle>
      <TextContent>Bad input parameter</TextContent>
      <TextContent><b><i>api: </i></b><HighlightText>https://api.bktraffic.com/api/traffic-status/get-status?zoom=18&time=1602998292539&date=1602998292539&lng=106.6772127205456</HighlightText> </TextContent>
      <JsonCodeStyle data={responseErrors} />

      <StyledSeparated />
    </div>
  )
}

GetTrafficStatus.propTypes = {

}

export default GetTrafficStatus
